import {
  Button,
  ListHeaderItem,
  ListItemCell,
  Modal,
  Typography,
} from "components/common";
import { ModalProps } from "components/common/Modal";
import { useConsoleState } from "providers/ConsoleStateProvider";
import React from "react";
import { Group } from "types/graphqlapi";
import { getUserQuery } from "utils/apis/user";

import {
  StyledListHeader,
  StyledListItemArea,
  StyledModalContent,
  StyledModalHeader,
} from "./styled";

type SelectGroupModalProps = {
  selectableGroupList: Group[];
  selectGroup: (groupId: string, groupName: string) => void;
} & ModalProps;

export const SelectGroupModal: React.FC<SelectGroupModalProps> = ({
  selectableGroupList,
  selectGroup,
  closeHandler,
}) => {
  const { setUserInfo, email } = useConsoleState();

  return (
    <Modal closeHandler={closeHandler}>
      <StyledModalHeader>
        <Typography text="グループ選択" fontSize="large" />
      </StyledModalHeader>
      <StyledModalContent>
        <StyledListHeader>
          <ListHeaderItem width={"80%"}>
            <Typography text={"グループ名"}></Typography>
          </ListHeaderItem>
          <ListHeaderItem width={"20%"}>
            <Typography text={""}></Typography>
          </ListHeaderItem>
        </StyledListHeader>
        {selectableGroupList
          ?.sort((a, b) => {
            if (a.createdAt < b.createdAt) return -1;
            if (a.createdAt > b.createdAt) return 1;
            return 0;
          })
          .map((group) => (
            <StyledListItemArea key={group.id}>
              <ListItemCell width={"80%"}>
                <Typography text={group.name} />
              </ListItemCell>
              <ListItemCell width={"20%"} align="center">
                <Button
                  label={"選択"}
                  size="small"
                  onClickHandler={async () => {
                    try {
                      const loginUser = await getUserQuery(email, group.id);
                      if (!loginUser) {
                        return;
                      }
                      setUserInfo(
                        loginUser?.id,
                        loginUser?.name,
                        loginUser?.role,
                        loginUser?.is_personal_data_handler || false
                      );
                      selectGroup(group.id, group.name);
                    } catch {
                      alert("エラーが発生しました。");
                    }
                  }}
                ></Button>
              </ListItemCell>
            </StyledListItemArea>
          ))}
      </StyledModalContent>
    </Modal>
  );
};
